module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider7Pre-54fae68d.jpeg";